import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { loadableReady } from '@loadable/component';

import App from '../containers/App';

// Package stylesheet first, project styles over it, tailwind utilities last. It is a
// module import rather than an @import in index.scss because dart-sass passes .css
// imports through as plain CSS @import rules, which are only valid ahead of any other
// rule - inside index.scss it was silently dropped and the calendar lost all styling.
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/index.scss';
import '../styles/tailwind.css';

// React 18's client entry point. Note the argument order is the reverse of the
// react-dom `hydrate` this replaces: container first, element second.
//
// Deliberately not wrapped in StrictMode. React 18's StrictMode double-invokes effects in
// development, which react-beautiful-dnd 13 does not survive - it is a known
// incompatibility and would break every drag-and-drop screen in the manager.
loadableReady(() => {
  hydrateRoot(
    document.getElementById('app'),
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
});
